// extracted by mini-css-extract-plugin
export var truncate = "_7-0";